export const UUID_ROUTE = '/analytics/uuid.json';
